/* Relative day label for a group header: Today / 1 Day ago / N Days ago */
export function relativeDay(date) {
  const start = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.round((start(new Date()) - start(date)) / 86400000);

  if (diffDays <= 0) return 'Today';
  if (diffDays === 1) return '1 Day ago';
  return `${diffDays} Days ago`;
}

/* Group timeline rows by calendar day, newest day first. */
export function groupByDay(rows = [], getTime) {
  const groups = new Map();

  rows.forEach((row) => {
    const date = new Date(getTime(row));
    if (Number.isNaN(date.getTime())) return;
    const key = date.toDateString();
    if (!groups.has(key)) groups.set(key, { date, items: [] });
    groups.get(key).items.push(row);
  });

  return [...groups.values()].sort((a, b) => b.date - a.date);
}

export function formatDate(value) {
  return new Date(value).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatTime(value) {
  return new Date(value).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
}
